module.exports = __webpack_public_path__ + "img/selected6-min.e3fb3e5e.png";